export const antibotKeys = {
    all: ['antibot'],
    verifyHumanity: () => [...antibotKeys.all, 'verifyHumanity'],
};
